//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/NXObject.js";
import "../no/NXColor.js";
import "../no/Validation.js";
let d=[[[0,"BitmapName",1,0],[0,"Color",1,0],[0,"CustomMessage",1,0],[0,"DisplayStyle",1,0],[0,"ErrorLevel",1,0],[0,"IsManual",1,0],[0,"IsNameUserSpecified",1,0],[0,"LowerBound",1,0],[0,"TagPriority",1,0],[0,"UpperBound",1,0],[0,"Value",1,0]],[],[]];
SPLM.VisualReporting.GroupLabel = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.VisualReporting.GroupLabel";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualReporting.GroupLabel.DisplayStyleOption = Object.freeze({
    "DeEmphasis" : "DeEmphasis", "SpecifiedColor" : "SpecifiedColor", "OriginalColor" : "OriginalColor", "AutomaticColor" : "AutomaticColor"});

SPLM.VisualReporting.GroupLabel.TagPriorityOption = Object.freeze({
    "Low" : "Low", "Medium" : "Medium", "High" : "High"});

export default SPLM;